/*
  Persona product page — Paper 03.N01 / 04.C01 / 05.B01 / 06.K01, D01 + M01–M03.

  One state object drives everything on the buying area:
    finish · length · type (none | text | crest) · preset · text · font · crest file

  The variant is DERIVED from that state, never chosen directly:
    type none  → Personalization = No Engraving
    type text  → the character tier that fits the text (1-3 / 4-10 Characters)
    type crest → Logo/Crest
  so the add-to-bag always posts the variant whose price is the real price, and
  every "+$…" on the page is that variant's price minus the No Engraving price.

  Finish (separate Gold / Silver products): the swatch is a link to the
  sibling. It is swapped in place — the sibling page is fetched, its product
  section replaces this one, and the product-dependent sections outside it
  (the per-product Description block and anything marked data-psp-sync) are
  re-pointed at the sibling's markup from the same response. The shopper's
  length, personalization, text, font and artwork carry across.

  Builder hand-off: ?finish=gold|silver&length=&type=none|text|crest&value=
  &font=&from=builder preselects and prefills. Every value is validated
  against what this product actually offers; anything unknown is ignored.
*/
(function () {
  'use strict';

  var FONTS = [
    { v: 'Arial', key: 'arial', label: 'Arial' },
    { v: 'Palatino', key: 'palatino', label: 'Palatino' },
    { v: 'Monotype Corsiva', key: 'corsiva', label: 'Monotype Corsiva' },
    { v: 'College Block', key: 'college', label: 'College Block' },
    { v: 'Times New Roman', key: 'times', label: 'Times New Roman' }
  ];
  var CREST_TYPES = /\.(png|jpe?g|svg|pdf)$/i;
  var CREST_MAX = 5 * 1024 * 1024;

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var n = (cents / 100).toFixed(2);
    var whole = n.replace(/\.00$/, '');
    var withCommas = function (x) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var fmt = format || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas(String(Math.round(cents / 100))))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas(whole.split('.')[0]) + (whole.indexOf('.') > -1 ? '.' + whole.split('.')[1] : ''))
      .replace(/<[^>]*>/g, '');
  }

  function lead(v) { return String(v || '').split(' - ')[0].trim(); }

  // Carried across an in-place finish swap.
  var carry = null;

  function init(root) {
    if (root.__psp) return;
    root.__psp = true;

    var cfgEl = $(root, '[data-psp-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var form = $(root, '[data-psp-form]');
    var idInput = $(root, '[data-psp-id]');
    var textInput = $(root, '[data-psp-text]');
    var fontInput = $(root, '[data-psp-font-input]');
    var fileInput = $(root, '[data-psp-file]');
    var notes = $(root, '[data-psp-notes]');
    var atc = $(root, '[data-psp-atc]');
    var atcLabel = $(root, '[data-psp-atc-label]');
    var idx = cfg.idx;
    var money = function (c) { return formatMoney(c, cfg.moneyFormat); };
    var initial = cfg.variants.filter(function (v) { return v.id === cfg.initialId; })[0] || cfg.variants[0];

    var state = {
      fin: idx.fin > -1 ? initial.options[idx.fin] : cfg.finish,
      len: idx.len > -1 ? initial.options[idx.len] : null,
      type: 'none',
      preset: null,
      text: '',
      font: FONTS[0].v,
      file: null,
      later: false,
      error: ''
    };
    if (idx.pers > -1 && cfg.hasVariantParam) {
      var pv = initial.options[idx.pers];
      if (pv === cfg.vCrest) state.type = 'crest';
      else if (pv !== cfg.vNone && cfg.tiers.some(function (t) { return t.v === pv; })) state.type = 'text';
    }

    /* ---------------- variant resolution ---------------- */

    function find(pers) {
      return cfg.variants.filter(function (v) {
        if (idx.len > -1 && v.options[idx.len] !== state.len) return false;
        if (idx.fin > -1 && v.options[idx.fin] !== state.fin) return false;
        if (idx.pers > -1 && pers != null && v.options[idx.pers] !== pers) return false;
        return true;
      })[0] || null;
    }
    function baseVariant() { return find(idx.pers > -1 ? cfg.vNone : null); }
    function tierFor(n) {
      var t = cfg.tiers.filter(function (t) { return t.max >= Math.max(n, 1); })[0];
      return t || cfg.tiers[cfg.tiers.length - 1] || null;
    }
    function chosenVariant() {
      if (idx.pers === -1) return baseVariant();
      if (state.type === 'text') { var t = tierFor(state.text.length); return find(t ? t.v : cfg.vNone); }
      if (state.type === 'crest') return find(cfg.vCrest);
      return baseVariant();
    }

    /* ---------------- rendering ---------------- */

    function setRowPrice(type, label, paid) {
      var el = $(root, '[data-psp-row-price="' + type + '"]');
      if (!el) return;
      el.textContent = label;
      el.classList.toggle('is-included', !paid);
    }

    function fontObj() { return FONTS.filter(function (f) { return f.v === state.font; })[0] || FONTS[0]; }

    function row(label, labelM, value, included) {
      return '<div class="psp__sumrow"><span><span class="psp__d"></span><span class="psp__m"></span></span><span' +
        (included ? ' class="is-included"' : '') + '></span></div>';
    }
    function sumRow(box, dText, mText, value, included) {
      box.insertAdjacentHTML('beforeend', row());
      var r = box.lastElementChild;
      var spans = r.querySelectorAll('span');
      spans[1].textContent = dText;
      spans[2].textContent = mText || dText;
      r.lastElementChild.textContent = value;
    }

    function render() {
      var base = baseVariant();
      var v = chosenVariant() || base;
      if (!v || !base) return;
      if (idInput) idInput.value = v.id;

      var basePrice = base.price;
      var total = v.price;
      var delta = total - basePrice;

      // header price and compare-at
      var bp = $(root, '[data-psp-base]');
      if (bp) bp.textContent = money(basePrice);
      var cmp = $(root, '[data-psp-compare]');
      if (cmp) {
        cmp.hidden = !(base.compare > base.price);
        cmp.textContent = money(base.compare);
      }

      // row prices from real variants
      if (idx.pers > -1) {
        var usable = cfg.tiers.filter(function (t, i) { return (i === 0 ? 1 : cfg.tiers[i - 1].max + 1) <= cfg.maxChars; });
        var deltas = usable.map(function (t) { var tv = find(t.v); return tv ? tv.price - basePrice : 0; });
        var mn = Math.min.apply(null, deltas), mx = Math.max.apply(null, deltas);
        if (deltas.length) setRowPrice('text', mx <= 0 ? 'Included' : (mn === mx ? '+' + money(mn) : 'From +' + money(mn)), mx > 0);
        var cv = find(cfg.vCrest);
        if (cv) setRowPrice('crest', cv.price - basePrice > 0 ? '+' + money(cv.price - basePrice) : 'Included', cv.price - basePrice > 0);
        var tiersEl = $(root, '[data-psp-tiers]');
        if (tiersEl) {
          var parts = [];
          var lo = 1;
          usable.forEach(function (t, i) {
            var hi = Math.min(t.max, cfg.maxChars);
            if (lo > hi) return;
            parts.push((lo === hi ? lo : lo + '–' + hi) + (hi === 1 ? ' character ' : ' characters ') + (deltas[i] > 0 ? '+' + money(deltas[i]) : 'included'));
            lo = t.max + 1;
          });
          tiersEl.hidden = !(parts.length > 1 && mn !== mx);
          tiersEl.textContent = parts.join(' · ');
        }
      } else {
        setRowPrice('text', cfg.fees.text || 'Included', !!cfg.fees.text);
        setRowPrice('crest', cfg.fees.crest || 'Included', !!cfg.fees.crest);
      }

      // finish label + swatches (parent model)
      var fv = $(root, '[data-psp-finish-value]');
      if (fv) fv.textContent = state.fin || '';
      $$(root, '[data-psp-finish]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-psp-finish') === state.fin));
      });
      $$(root, '[data-psp-len]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-psp-len') === state.len));
      });

      // personalization rows + panels
      $$(root, '[data-psp-type]').forEach(function (b) {
        var on = b.getAttribute('data-psp-type') === state.type;
        b.setAttribute('aria-checked', String(on));
        b.tabIndex = on ? 0 : -1;
        b.closest('.psp__opt').classList.toggle('is-selected', on);
      });
      $$(root, '[data-psp-panel]').forEach(function (p) {
        var on = p.getAttribute('data-psp-panel') === state.type;
        p.hidden = !on;
      });
      // Only the active panel's fields submit; Shopify drops disabled inputs.
      if (textInput) textInput.disabled = state.type !== 'text';
      if (fontInput) { fontInput.disabled = state.type !== 'text'; fontInput.value = state.font; }
      if (fileInput) fileInput.disabled = state.type !== 'crest';
      if (notes) notes.disabled = state.type !== 'crest';

      // chips, placeholder, helper
      var presetEl = null;
      $$(root, '[data-psp-preset]').forEach(function (c) {
        var on = c.getAttribute('data-psp-preset') === state.preset;
        c.setAttribute('aria-pressed', String(on));
        if (on) presetEl = c;
      });
      if (textInput) {
        textInput.placeholder = presetEl ? presetEl.getAttribute('data-placeholder') : textInput.getAttribute('data-empty-ph') || textInput.placeholder;
        var mode = presetEl ? presetEl.getAttribute('data-mode') : '';
        textInput.inputMode = mode === 'numeric' ? 'numeric' : 'text';
        textInput.autocapitalize = mode === 'custom' ? 'sentences' : 'characters';
        if (textInput.value !== state.text) textInput.value = state.text;
        var help = $(root, '[data-psp-help]');
        if (help) help.textContent = mode === 'custom' && help.getAttribute('data-custom') ? help.getAttribute('data-custom') : help.getAttribute('data-default');
      }

      // counter + error
      var counter = $(root, '[data-psp-counter]');
      if (counter) {
        counter.textContent = state.text.length + ' / ' + cfg.maxChars;
        counter.classList.toggle('is-full', state.text.length >= cfg.maxChars);
      }
      var field = $(root, '[data-psp-field]');
      var err = $(root, '[data-psp-error]');
      if (field) field.classList.toggle('is-error', !!state.error);
      if (err) { err.hidden = !state.error; err.textContent = state.error; }
      if (textInput) textInput.setAttribute('aria-invalid', String(!!state.error));

      // fonts
      $$(root, '[data-psp-font]').forEach(function (b) {
        var on = b.getAttribute('data-psp-font') === state.font;
        b.setAttribute('aria-checked', String(on));
        b.tabIndex = on ? 0 : -1;
      });

      // preview plate
      var stage = $(root, '[data-psp-stage]');
      var etch = $(root, '[data-psp-etch]');
      var f = fontObj();
      if (stage) {
        stage.setAttribute('data-finish', String(state.fin || '').toLowerCase());
        stage.classList.toggle('is-empty', !state.text);
      }
      if (etch) {
        etch.textContent = state.text;
        etch.className = 'psp__etch psp-f--' + f.key + (state.text.length <= 2 ? ' is-short' : '');
      }
      var cap = $(root, '[data-psp-caption]');
      if (cap) cap.textContent = state.text ? [state.fin, state.text, f.label].filter(Boolean).join(' · ') : '';

      // crest upload row
      var drop = $(root, '[data-psp-drop]');
      var upl = $(root, '[data-psp-upl]');
      if (drop && upl) {
        drop.hidden = !!state.file;
        upl.hidden = !state.file;
        if (state.file) {
          $(root, '[data-psp-upl-name]').textContent = state.file.name;
          var th = $(root, '[data-psp-upl-thumb]');
          th.innerHTML = '';
          if (/^image\//.test(state.file.type)) {
            var img = document.createElement('img');
            img.alt = '';
            img.src = URL.createObjectURL(state.file);
            th.appendChild(img);
          } else {
            th.textContent = (state.file.name.split('.').pop() || '').toUpperCase();
          }
        }
      }
      var later = $(root, '[data-psp-later]');
      if (later) later.setAttribute('aria-pressed', String(state.later));

      // summary
      var box = $(root, '[data-psp-summary]');
      if (box) {
        box.innerHTML = '';
        var lenLead = state.len ? lead(state.len) : '';
        var line1 = [cfg.name, state.fin, lenLead].filter(Boolean).join(' · ');
        var line1m = [cfg.pieceLabel, state.fin, lenLead].filter(Boolean).join(' · ');
        sumRow(box, line1, line1m, money(basePrice));
        if (cfg.fitSummary) sumRow(box, 'Fit · ' + cfg.fitSummary, null, 'Included', true);
        if (state.type === 'text') {
          var tl = cfg.textLabel + (state.text ? ' · ' + state.text : '');
          sumRow(box, tl, 'Text' + (state.text ? ' · ' + state.text : ''), delta > 0 ? '+' + money(delta) : (idx.pers === -1 && cfg.fees.text ? cfg.fees.text : 'Included'), delta <= 0);
          sumRow(box, 'Font · ' + f.label, null, 'Included', true);
        } else if (state.type === 'crest') {
          var cl = cfg.crestLabel + (state.file ? ' · ' + state.file.name : (state.later ? ' · artwork to follow' : ''));
          sumRow(box, cl, 'Crest' + (state.file ? ' · uploaded' : ''), delta > 0 ? '+' + money(delta) : (idx.pers === -1 && cfg.fees.crest ? cfg.fees.crest : 'Included'), delta <= 0);
        }
        $$(box, '.is-included').forEach(function (n) { n.classList.add('is-included'); });
      }

      // add to bag
      var blocked = state.type === 'text' && !state.text;
      if (atc) {
        atc.disabled = !v.available;
        atc.classList.toggle('is-blocked', blocked);
        atc.setAttribute('aria-disabled', String(blocked || !v.available));
        if (atcLabel) atcLabel.textContent = v.available ? 'Add to bag · ' + money(total) : 'Sold out';
      }

      // sticky bar
      var sc = $(root, '[data-psp-sticky-cfg]');
      if (sc) {
        var tlab = state.type === 'text' ? (state.text || 'Text') : state.type === 'crest' ? 'Crest' : '';
        sc.textContent = [state.fin, lenLead, tlab].filter(Boolean).join(' · ');
      }
      var sp = $(root, '[data-psp-sticky-price]');
      if (sp) sp.textContent = money(total);
      var sb = $(root, '[data-psp-sticky-btn]');
      if (sb) { sb.disabled = !v.available; sb.classList.toggle('is-blocked', blocked); sb.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      var st = $(root, '[data-psp-sticky-thumb] img');
      if (st && v.img) st.src = v.img;

      gallerySync();
    }

    /* ---------------- URL ---------------- */

    function syncUrl() {
      var v = chosenVariant();
      if (!v || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      ['finish', 'length', 'type', 'value', 'font', 'from', 'crest'].forEach(function (k) { url.searchParams.delete(k); });
      url.searchParams.set('variant', v.id);
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }

    function update(opts) {
      render();
      if (!opts || opts.url !== false) syncUrl();
    }

    /* ---------------- controls ---------------- */

    function setType(t, focus) {
      if (t === state.type) return;
      state.type = t;
      state.error = '';
      if (t === 'text' && !state.preset && cfg.defaultPreset) state.preset = cfg.defaultPreset;
      update();
      if (focus && t === 'text' && textInput) textInput.focus({ preventScroll: true });
    }

    $$(root, '[data-psp-type]').forEach(function (b, i, all) {
      b.addEventListener('click', function () { setType(b.getAttribute('data-psp-type')); });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = all[(i + d + all.length) % all.length];
        setType(n.getAttribute('data-psp-type'));
        n.focus();
      });
    });

    $$(root, '[data-psp-preset]').forEach(function (c) {
      c.addEventListener('click', function () {
        state.preset = c.getAttribute('data-psp-preset');
        var mode = c.getAttribute('data-mode');
        if (mode === 'numeric' && /\D/.test(state.text)) state.text = state.text.replace(/\D/g, '');
        state.error = '';
        update({ url: false });
        if (textInput) textInput.focus({ preventScroll: true });
      });
    });

    if (textInput) {
      textInput.setAttribute('data-empty-ph', textInput.placeholder);
      // The limit is enforced here rather than by maxlength, so an 11th
      // character (typed or pasted) is refused WITH the reason shown.
      textInput.removeAttribute('maxlength');
      textInput.addEventListener('input', function () {
        var val = textInput.value.replace(/[\r\n\t]/g, ' ');
        var chip = $(root, '[data-psp-preset][aria-pressed="true"]');
        if (chip && chip.getAttribute('data-mode') === 'numeric') val = val.replace(/\D/g, '');
        state.error = '';
        if (val.length > cfg.maxChars) {
          // Pasted past the limit: keep the last valid value and say why.
          val = val.slice(0, cfg.maxChars);
          state.error = cfg.errLimit;
        }
        state.text = val;
        render();
        syncUrl();
      });
    }

    $$(root, '[data-psp-font]').forEach(function (b, i, all) {
      b.addEventListener('click', function () { state.font = b.getAttribute('data-psp-font'); render(); });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = all[(i + d + all.length) % all.length];
        state.font = n.getAttribute('data-psp-font');
        render();
        n.focus();
      });
    });

    $$(root, '[data-psp-len]').forEach(function (b) {
      b.addEventListener('click', function () { state.len = b.getAttribute('data-psp-len'); update(); });
    });
    $$(root, '[data-psp-finish]').forEach(function (b) {
      b.addEventListener('click', function () { state.fin = b.getAttribute('data-psp-finish'); gallery.go(0); update(); });
    });

    // crest
    function crestError(msg) {
      var e = $(root, '[data-psp-crest-error]');
      var drop = $(root, '[data-psp-drop]');
      if (e) { e.hidden = !msg; e.textContent = msg || ''; }
      if (drop) drop.classList.toggle('is-error', !!msg);
    }
    function setFile(file) {
      if (!file) { state.file = null; if (fileInput) fileInput.value = ''; crestError(''); render(); return; }
      if (!CREST_TYPES.test(file.name)) {
        state.file = null; fileInput.value = '';
        crestError('This file type isn’t supported. Upload a PNG, JPG, SVG or PDF.');
        render(); return;
      }
      if (file.size > CREST_MAX) {
        state.file = null; fileInput.value = '';
        crestError('That file is over 5 MB. Upload a smaller file, or choose Send it later.');
        render(); return;
      }
      crestError('');
      state.file = file;
      state.later = false;
      render();
    }
    if (fileInput) {
      fileInput.addEventListener('change', function () { setFile(fileInput.files && fileInput.files[0]); });
      var rep = $(root, '[data-psp-replace]');
      if (rep) rep.addEventListener('click', function () { fileInput.click(); });
      var rem = $(root, '[data-psp-remove]');
      if (rem) rem.addEventListener('click', function () { setFile(null); });
      var laterBtn = $(root, '[data-psp-later]');
      if (laterBtn) laterBtn.addEventListener('click', function () {
        state.later = !state.later;
        if (state.later) setFile(null);
        crestError('');
        render();
      });
    }

    /* ---------------- gallery ---------------- */

    var gallery = (function () {
      var track = $(root, '[data-psp-track]');
      var slides = $$(root, '[data-psp-slide]');
      var thumbs = $$(root, '[data-psp-thumb]');
      var dots = $$(root, '[data-psp-dot]');
      var count = $(root, '[data-psp-count]');
      var current = 0;
      var visible = slides;
      if (!track) return { go: function () {}, sync: function () {} };

      function filter() {
        var fin = state.fin || '';
        visible = [];
        slides.forEach(function (s, i) {
          var g = s.getAttribute('data-finish') || '';
          var show = idx.fin === -1 || !g || g === fin;
          s.hidden = !show;
          if (thumbs[i]) thumbs[i].hidden = !show;
          if (dots[i]) dots[i].hidden = !show;
          if (show) visible.push(s);
        });
      }
      function mark(i) {
        current = i;
        var active = visible[i];
        slides.forEach(function (s, n) {
          var on = s === active;
          if (thumbs[n]) {
            thumbs[n].classList.toggle('is-active', on);
            thumbs[n].setAttribute('aria-selected', String(on));
            thumbs[n].tabIndex = on ? 0 : -1;
          }
          if (dots[n]) dots[n].classList.toggle('is-active', on);
        });
        if (count) count.textContent = (i + 1) + ' / ' + visible.length;
      }
      function go(i, smooth) {
        if (!visible[i]) i = 0;
        mark(i);
        if (visible[i]) track.scrollTo({ left: visible[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }
      var t = null;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var x = track.scrollLeft, best = 0, gap = Infinity;
          visible.forEach(function (s, i) {
            var d = Math.abs(s.offsetLeft - track.offsetLeft - x);
            if (d < gap) { gap = d; best = i; }
          });
          if (best !== current) mark(best);
        }, 80);
      }, { passive: true });
      thumbs.forEach(function (th, n) {
        th.addEventListener('click', function () { go(visible.indexOf(slides[n]), true); });
        th.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var ni = Math.max(0, Math.min(visible.length - 1, current + d));
          go(ni, true);
          var tn = thumbs[slides.indexOf(visible[ni])];
          if (tn) tn.focus();
        });
      });

      // Zoom: plain backdrop, no carousel controls; Escape or a click outside
      // closes it and leaves the gallery on the same slide.
      var dlg = $(root, '[data-psp-zoomdlg]');
      var zimg = $(root, '[data-psp-zoom-img]');
      function openZoom() {
        var s = visible[current];
        if (!dlg || !s) return;
        zimg.src = s.getAttribute('data-zoom');
        var im = s.querySelector('img');
        zimg.alt = im ? im.alt : '';
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      }
      var zb = $(root, '[data-psp-zoom]');
      if (zb) zb.addEventListener('click', openZoom);
      slides.forEach(function (s) { s.addEventListener('click', openZoom); });
      if (dlg) {
        dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-psp-zoom-close]')) dlg.close(); });
      }
      filter();
      mark(0);
      window.addEventListener('resize', function () { go(current); });
      return { go: go, sync: function () { var before = visible.length; filter(); if (visible.length !== before) go(0); } };
    })();
    function gallerySync() { if (gallery) gallery.sync(); }

    /* ---------------- guide dialog ---------------- */

    var guide = $(root, '[data-psp-guide]');
    $$(root, '[data-psp-guide-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!guide) return;
        if (guide.showModal) guide.showModal(); else guide.setAttribute('open', '');
      });
    });
    if (guide) guide.addEventListener('click', function (e) {
      if (e.target === guide || e.target.closest('[data-psp-guide-close]')) guide.close();
    });

    /* ---------------- accordions: desktop opens Product details ---------------- */

    if (window.matchMedia('(min-width: 990px)').matches) {
      var first = $(root, '[data-psp-acc-first]');
      if (first) first.setAttribute('aria-expanded', 'true');
    }

    /* ---------------- sticky bar (mobile) ---------------- */

    var sticky = $(root, '[data-psp-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var atcOut = false, typing = false;
      var paint = function () {
        var show = atcOut && !typing;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        var btn = $(sticky, 'button');
        if (btn) btn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (en) {
        // Only show once the inline button has scrolled ABOVE the viewport.
        atcOut = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        paint();
      }).observe(atc);
      root.addEventListener('focusin', function (e) { if (e.target.matches('input, textarea')) { typing = true; paint(); } });
      root.addEventListener('focusout', function (e) { if (e.target.matches('input, textarea')) { typing = false; paint(); } });
      var footer = document.querySelector('footer, .ps-footer, [id*="footer"]');
      if (footer) new IntersectionObserver(function (en) { sticky.classList.toggle('is-parked', en[0].isIntersecting); }).observe(footer);
    }

    /* ---------------- submit ---------------- */

    function validate() {
      if (state.type === 'text' && !state.text.trim()) {
        state.error = cfg.errEmpty;
        render();
        if (textInput) textInput.focus();
        return false;
      }
      if (state.type === 'text' && state.text.length > cfg.maxChars) {
        state.error = cfg.errLimit; render(); return false;
      }
      return true;
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate()) return;
      var v = chosenVariant();
      if (!v || !v.available) return;
      idInput.value = v.id;
      if (state.type === 'crest' && notes) {
        // "Send it later" rides on the existing notes property so fulfilment
        // sees it without a new field.
        var n = notes.value.trim();
        if (state.later && !state.file && n.indexOf('Artwork to follow') !== 0) notes.value = 'Artwork to follow by email' + (n ? ' — ' + n : '');
      }
      var data = new FormData(form);
      // Never send empty properties (an empty file part, blank notes).
      var drop = [];
      data.forEach(function (val, key) {
        if (key.indexOf('properties[') !== 0) return;
        if ((typeof val === 'string' && !val.trim()) || (typeof val === 'object' && val && !val.size)) drop.push(key);
      });
      drop.forEach(function (key) { data.delete(key); });
      if (state.type === 'crest' && notes) notes.value = notes.value.replace(/^Artwork to follow by email( — )?/, '');
      var drawer = document.querySelector('cart-drawer');
      var errBox = $(root, '[data-psp-cart-error]');
      if (errBox) errBox.hidden = true;
      if (!window.fetch) { form.submit(); return; }
      if (drawer && drawer.getSectionsToRender) {
        data.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        data.append('sections_url', window.location.pathname);
        if (drawer.setActiveElement) drawer.setActiveElement(atc);
      }
      atc.setAttribute('aria-busy', 'true');
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (errBox) { errBox.hidden = false; errBox.textContent = res.description || res.message || 'Could not add to bag.'; }
            return;
          }
          if (drawer && drawer.renderContents) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          document.dispatchEvent(new CustomEvent('psp:added', { detail: res }));
        })
        .catch(function () { form.submit(); })
        .then(function () { atc.removeAttribute('aria-busy'); });
    });

    /* ---------------- finish swap (separate products) ---------------- */

    var sibLink = $(root, '[data-psp-sibling]');
    if (sibLink) sibLink.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      swapTo(sibLink.getAttribute('href'), true);
    });

    function snapshot() {
      return {
        len: state.len ? lead(state.len) : null,
        type: state.type, preset: state.preset, text: state.text, font: state.font,
        file: state.file, later: state.later, notes: notes ? notes.value : ''
      };
    }

    function swapTo(url, push) {
      if (root.__swapping) return;
      root.__swapping = true;
      var section = root.closest('[id^="shopify-section-"]');
      root.setAttribute('aria-busy', 'true');
      root.classList.add('is-swapping');
      carry = snapshot();
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = doc.querySelector('[data-ps-pdp]');
          var fresh = freshRoot && freshRoot.closest('[id^="shopify-section-"]');
          if (!fresh || !section) throw new Error('no section');
          section.innerHTML = fresh.innerHTML;
          // Product-dependent blocks outside this section: the per-product
          // Description (custom liquid) and any section marked data-psp-sync.
          syncOutside(doc, '.persona-product-details');
          $$(document, '[data-psp-sync]').forEach(function (el) {
            syncOutside(doc, '[data-psp-sync="' + el.getAttribute('data-psp-sync') + '"]');
          });
          var t = doc.querySelector('title');
          if (t) document.title = t.textContent;
          var newRoot = section.querySelector('[data-ps-pdp]');
          init(newRoot);
          if (push) {
            var id = newRoot.querySelector('[data-psp-id]');
            window.history.pushState({ psp: true }, '', url.split('?')[0] + (id ? '?variant=' + id.value : ''));
          }
          document.dispatchEvent(new CustomEvent('psp:finish-swapped', { detail: { url: url } }));
        })
        .catch(function () { window.location.href = url; });
    }

    function syncOutside(doc, selector) {
      var cur = document.querySelector(selector);
      var next = doc.querySelector(selector);
      if (!cur || !next || root.contains(cur)) return;
      var cs = cur.closest('[id^="shopify-section-"]');
      var ns = next.closest('[id^="shopify-section-"]');
      if (cs && ns) cs.innerHTML = ns.innerHTML;
      else cur.replaceWith(next.cloneNode(true));
    }

    /* ---------------- initial state: carried, builder params, defaults ---------------- */

    function pickLen(want) {
      if (idx.len === -1 || !want) return false;
      var w = String(want).replace(/["″”]/g, '').trim().toLowerCase();
      var vals = $$(root, '[data-psp-len]').map(function (b) { return b.getAttribute('data-psp-len'); });
      var hit = vals.filter(function (v) { return lead(v).replace(/["″”]/g, '').toLowerCase() === w; })[0];
      if (hit) { state.len = hit; return true; }
      return false;
    }
    function applyText(val) {
      val = String(val || '').replace(/[\u0000-\u001f<>]/g, '').trim().slice(0, cfg.maxChars);
      state.text = val;
    }
    function applyFont(val) {
      if (!val) return;
      var w = String(val).toLowerCase();
      var f = FONTS.filter(function (f) { return f.v.toLowerCase() === w || f.label.toLowerCase() === w || f.key === w || (w.length > 3 && f.label.toLowerCase().indexOf(w) > -1); })[0];
      if (f) state.font = f.v;
    }

    var params = new URLSearchParams(window.location.search);
    if (carry) {
      var c = carry;
      carry = null;
      pickLen(c.len);
      var avail = $(root, '[data-psp-type="' + c.type + '"]');
      if (avail) state.type = c.type;
      state.preset = c.preset;
      applyText(c.text);
      state.font = c.font;
      state.later = c.later;
      if (notes) notes.value = c.notes || '';
      if (c.file && fileInput && window.DataTransfer) {
        try { var dt = new DataTransfer(); dt.items.add(c.file); fileInput.files = dt.files; state.file = c.file; } catch (e) {}
      }
    } else if (params.has('type') || params.has('finish') || params.has('length') || params.has('value')) {
      var pf = (params.get('finish') || '').toLowerCase();
      if (pf === 'gold' || pf === 'silver') {
        var want = pf.charAt(0).toUpperCase() + pf.slice(1);
        if (idx.fin > -1) {
          var fb = $$(root, '[data-psp-finish]').filter(function (b) { return b.getAttribute('data-psp-finish').toLowerCase().indexOf(pf) > -1; })[0];
          if (fb) state.fin = fb.getAttribute('data-psp-finish');
        } else if (cfg.sibling && cfg.finish !== want && String(cfg.sibling.finish).toLowerCase() === pf) {
          // Wrong finish for this product: hand the whole query to the sibling.
          window.location.replace(cfg.sibling.url + window.location.search);
          return;
        }
      }
      if (!pickLen(params.get('length')) && !cfg.hasVariantParam) pickLen(cfg.defaultLength);
      var pt = (params.get('type') || '').toLowerCase();
      if ((pt === 'text' || pt === 'crest' || pt === 'none') && $(root, '[data-psp-type="' + pt + '"]')) state.type = pt;
      // builder hand-off: "Send it later" chosen for the crest artwork
      if (state.type === 'crest' && params.get('crest') === 'later' && $(root, '[data-psp-later]')) state.later = true;
      if (state.type === 'text') {
        applyText(params.get('value'));
        applyFont(params.get('font'));
        if (/^\d+$/.test(state.text)) {
          var num = $(root, '[data-psp-preset][data-mode="numeric"]');
          if (num) state.preset = num.getAttribute('data-psp-preset');
        }
        if (!state.preset) {
          var custom = $(root, '[data-psp-preset][data-mode="custom"]');
          state.preset = state.text ? (custom ? custom.getAttribute('data-psp-preset') : null) : cfg.defaultPreset;
        }
      }
      if (params.get('from') === 'builder') {
        var target = $(root, '[data-psp-opt="' + state.type + '"]') || $(root, '.psp__buy');
        if (target && state.type !== 'none') setTimeout(function () { target.scrollIntoView({ block: 'center' }); }, 60);
      }
    } else if (!cfg.hasVariantParam) {
      pickLen(cfg.defaultLength);
    }
    if (state.type === 'text' && !state.preset && cfg.defaultPreset && !state.text) state.preset = cfg.defaultPreset;

    update({ url: params.has('type') || params.has('value') || params.has('finish') || params.has('length') || !!carry });
    root.removeAttribute('aria-busy');
  }

  function boot() { document.querySelectorAll('[data-ps-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.psp) window.location.reload();
    else if (document.querySelector('[data-ps-pdp]') && !/[?&]variant=/.test(window.location.search) && window.__pspPushed) window.location.reload();
  });
  document.addEventListener('psp:finish-swapped', function () { window.__pspPushed = true; });
})();
